import { render } from "./LeaveItem.vue?vue&type=template&id=87bab51a&scoped=true&ts=true"
import script from "./LeaveItem.vue?vue&type=script&lang=ts"
export * from "./LeaveItem.vue?vue&type=script&lang=ts"

import "./LeaveItem.vue?vue&type=style&index=0&id=87bab51a&lang=scss&scoped=true"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87bab51a"]])

export default __exports__